module.exports = __webpack_public_path__ + "assets/images/2c4a5e10898ee5e87d2bd56dd37369bf.png";